import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { deLoc, enLoc, esLoc, frLoc, itLoc } from 'shared'

const resources = {
  en: {
    translation: enLoc,
  },
  de: {
    translation: deLoc,
  },
  fr: {
    translation: frLoc,
  },
  it: {
    translation: itLoc,
  },
  es: {
    translation: esLoc,
  },
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
